var UploaderAvatar = {
  props: {
    name: { default: '¿?' },
    value: { default: false },
    endpoint: { default: '/directorio/avatar/' },
  },

  components: {
    avatar: Avatar,
  },

  data: function () {
    return {
      file: false,
      loading: false,
      progress: 0,
    };
  },

  computed: {},

  watch: {},

  mounted: function () {
    UIkit.upload(this.$el, {
      type: 'json',
      name: 'file',
      url: this.endpoint,
      multiple: false,
      //maxSize: 2048,
      allow: '*.(jpg|png|gif)',

      i18n: UIkitUploadI18n,

      beforeAll: (uploader, files) => {
        //console.log('uploader.beforeAll', uploader, files);
      },
      beforeSend: async (env) => {
        let file = env.data.get('file');

        console.log(file);
        if (file.type === 'image/jpeg' || file.type === 'image/x-png') {
          file = await resizeImage(file);
        }

        if (file.size > 2 * 1024 * 1024) {
          throw new Error(UIkitUploadI18n.invalidSize);
        }

        env.data.set('file', file);
      },

      loadStart: (e) => {
        //console.log('start', e);
      },
      progress: (e) => {
        this.progress = Math.round((100 * e.loaded) / e.total);
        //console.log('progress', e, this.progress);
      },
      loadEnd: (e) => {
        this.progress = 0;
        //console.log('end', e);
      },
      error: (e) => {
        this.progress = 0;
        let error = e.message;
        switch (e.status) {
          case 413:
            error = UIkitUploadI18n.invalidSize;
        }
        customAlert('Ha ocurrido un error', error);
        console.error(e);
      },
      fail: (e) => {
        customAlert('Ha ocurrido un error', e);
      },
      complete: (xhr) => {
        //console.log('complete', xhr);
        this.$emit('input', xhr.response);
      },
    });
  },

  methods: {},

  template: `
      <div class="uk-uploader">
      <div uk-form-custom>
        <input 
          title="" 
          type="file"
          accept="image/jpeg, image/gif, image/x-png, image/webp"
        />
        <avatar :name="name" :image="value.url"/>
      </div>
      <progress class="uk-progress" :value="progress" max="100" v-if="progress > 0" />
      </div>
	`,
};
